import type { IHeaderNavLink, IMainFilter } from 'components/utils/Interfaces';
import * as config from '@/constants/Config';

const PRODUCT_FILTERS: IMainFilter[] = [
  {
    title: 'Types',
    isSelected: false,
    tag: 'productType',
  },
  {
    title: 'Brands',
    isSelected: false,
    tag: 'brand',
  },
  {
    title: 'Styles',
    isSelected: false,
    tag: 'style',
  },
  {
    title: 'Price',
    isSelected: false,
    tag: 'priceIndicator',
  },
  {
    title: 'Made For',
    isSelected: false,
    tag: 'madeFor',
  },
  {
    title: 'Season',
    isSelected: false,
    tag: 'season',
  },
];

const DESIGN_FILTERS: IMainFilter[] = [
  {
    title: 'Organizations',
    tag: 'org',
    isSelected: false,
  },
  {
    title: 'Events',
    tag: 'event',
    isSelected: false,
  },
  {
    title: 'Style',
    tag: 'style',
    isSelected: false,
  },
  {
    title: 'Great For',
    tag: 'product_type',
    isSelected: false,
  },
];

export const BRANDS_TO_SHOW_FIRST = [
  'Comfort Colors',
  'Nike',
  'Adidas',
  'American Apparel',
  'Charles River',
  'Fresh Prints',
];

export const POPULAR_BRAND_ARRAY = [
  'Fresh Prints',
  'Comfort Colors',
  'Charles River',
  'Gildan',
  'Adidas',
  'Nike',
  'Bella Canvas',
  'The North Face',
  'Champion',
  'Vineyard Vines',
  'Southern Tide',
  'Under Armour',
  'Next Level',
  'Alternative',
  'Carhartt',
];

export const FP_WORDMARK_SRC = '/src/assets/svg/fp_wordmark.svg';

export const HEADER_NAV_LINKS: IHeaderNavLink[] = [
  {
    id: 1,
    path: `${config.FP_APP_URL}designs`,
    label: 'Designs',
    className: 'designs',
    hasDropdown: true,
    isSelected: false,
    mainFilters: DESIGN_FILTERS,
  },
  {
    id: 2,
    path: `${config.FP_APP_URL}products`,
    label: 'Products',
    className: 'products',
    hasDropdown: true,
    isSelected: false,
    mainFilters: PRODUCT_FILTERS,
  },
  {
    id: 3,
    label: 'Chapters',
    className: 'chapters',
    path: `${config.FP_APP_URL}chapters`,
    hasDropdown: true,
    isSelected: false,
  },
  {
    id: 4,
    path: config.LOOKBOOK_URL,
    label: 'Lookbook',
    className: 'lookbook',
    hasDropdown: false,
  },
];

export const CORP_SERVICES_FILTERS: IMainFilter[] = [
  {
    title: '',
    isSelected: false,
    tag: 'print',
    categories: [
      { title: 'Printing', urlEndPoint: 'printing' },
      { title: 'Fulfillment', urlEndPoint: 'fulfillment' },
      { title: 'Brand Consulation', urlEndPoint: 'brand-consultation' },
    ],
  },
];

export const CORP_CSR_FILTERS: IMainFilter[] = [
  {
    title: '',
    isSelected: false,
    tag: 'CSR',
    categories: [
      {
        title: 'BIPOC-Owned Brands',
        urlEndPoint: 'bipoc-owned-brands',
      },
      {
        title: 'Women-Owned Brands',
        urlEndPoint: 'women-owned-brands',
      },
      {
        title: 'Sustainable Brands',
        urlEndPoint: 'sustainable-brands',
      },
    ],
  },
];

export const CORP_THEMES_FILTERS: IMainFilter[] = [
  {
    title: '',
    isSelected: false,
    tag: 'themes',
    categories: [
      {
        title: 'Creator',
        urlEndPoint: 'creator',
      },
      {
        title: 'Explorer',
        urlEndPoint: 'explorer',
      },
      {
        title: 'Jester',
        urlEndPoint: 'jester',
      },
      {
        title: 'Innocent',
        urlEndPoint: 'innocent',
      },
      {
        title: 'Lover',
        urlEndPoint: 'lover',
      },
      {
        title: 'Everyman',
        urlEndPoint: 'everyman',
      },
      {
        title: 'Hero',
        urlEndPoint: 'hero',
      },
      {
        title: 'Ruler',
        urlEndPoint: 'ruler',
      },
      {
        title: 'Outlaw',
        urlEndPoint: 'outlaw',
      },
      {
        title: 'Sage',
        urlEndPoint: 'sage',
      },
      {
        title: 'Caregiver',
        urlEndPoint: 'caregiver',
      },
      {
        title: 'Magician',
        urlEndPoint: 'magician',
      },
    ],
  },
];

export const CORP_HEADER_NAV_LINKS: IHeaderNavLink[] = [
  {
    id: 1,
    path: `${config.CORP_APP_URL}products`,
    label: 'Products',
    className: 'corp-nav-link',
    hasDropdown: false,
    isSelected: false,
  },
  {
    id: 2,
    path: `${config.CORP_APP_URL}services`,
    label: 'Services',
    className: 'corp-nav-link',
    hasDropdown: false,
    isSelected: false,
  },
  {
    id: 3,
    path: `${config.CORP_APP_URL}collections`,
    label: 'Collections',
    className: 'corp-nav-link',
    hasDropdown: false,
    isSelected: false,
  },
];

export const SMS_TEXT = 'Text Us (929) 565-6850';
export const FP_LOGO_STACKED = '/src/assets/png/fp.png';
export const FP_LOGO_WORDMARK = '/src/assets/svg/fp_hoz_logo.svg';
export const DASHBOARD = 'Your Dashboard';

export const MEMBERS_PILL_COLORS = [
  { color: '#F49B50', bgColor: '#FFFBF8', borderColor: '#FCDBC2' },
  { color: '#EB79C5', bgColor: '#FFF8FD', borderColor: '#FDDBF2' },
  { color: '#519EEB', bgColor: '#F8FCFF', borderColor: '#B4D3F2' },
  { color: '#E86868', bgColor: '#FFFAFA', borderColor: '#FCDFDF' },
  { color: '#8066F0', bgColor: '#FBFAFF', borderColor: '#E1D9FF' },
  { color: '#38B896', bgColor: '#FAFFFE', borderColor: '#C8FCEE' },
  { color: '#337AB7', bgColor: '#FBFDFF', borderColor: '#AED1F2' },
  { color: '#AAB2C3', bgColor: '#FCFCFF', borderColor: '#E2E6F2' },
  { color: '#474B6D', bgColor: '#FCFCFD', borderColor: '#C5C5DB' },
];

export const SCHOOL_PROPS = {
  loading: false,
  notFoundContent: 'No School Found',
  name: 'school',
  floatingLabel: true,
  placeholder: 'Select a school',
  selectWrapperStyles: { width: '300px' },
  suffixIcon: true,
  options: [],
};

export const ORG_PROPS = {
  loading: false,
  notFoundContent: 'No Organization Found',
  name: 'organization',
  floatingLabel: true,
  placeholder: 'Select an organization',
  selectWrapperStyles: { width: '300px' },
  suffixIcon: true,
  options: [],
};

export const FIELD_ERR_MSGS = {
  FULLNAME_REQUIRED: 'What’s your full name?',
  FULLNAME_INVALID: 'What’s your full name?',
  PHONE_REQUIRED: 'What’s your phone number?',
  PHONE_INVALID: 'No spam calls, promise',
  EMAIL_REQUIRED: 'What’s your email?',
  EMAIL_INVALID: 'That’s not a valid email, silly!?',
  EMAIL_EXISTS: 'An account with this email already exists',
  CURRENT_PASSWORD_REQUIRED: 'Enter current password',
  PASSWORD_INVALID: 'Incorrect password',
  NEW_PASSWORD_REQUIRED: 'Set the new password',
  CONFIRM_PASSWORD_REQUIRED: 'Confirm the new password',
  CONFIRM_PASSWORD_INVALID: "Passwords don't match",
  PHONE_NUMBER_INVALID: "That's not an actual number, silly!",
  ADVISOR_NAME: "What's the advisor's full name?",
  ADVISOR_PHONE: 'Enter the phone number.',
  QUANTITY: 'Enter the estimated quantity, please.',
  WHO_IS_PAYING: "Select who's paying.",
  PURPOSE: ' Select a purpose.',
};

const APPLY_CM = 'https://apply.freshprints.com/?utm_source=website&utm_medium=sidebar';
const SCHOLAR_SHIP = 'http://apply.freshprints.com/fp-scholarship-page';
const BLOG = 'https://blog.freshprints.com';
const CAREERS = 'https://apply.freshprints.com/careers-page';

export const MOBILE_NAV_LINKS = [
  { id: 1, path: `${config.FP_APP_URL}about`, label: 'About Us' },
  { id: 2, path: `${config.FP_APP_URL}about`, label: 'Our Campus Managers' },
  { id: 3, path: APPLY_CM, label: 'Apply to be a Campus Manager' },
  { id: 4, path: SCHOLAR_SHIP, label: 'Apply for Our Scholarship' },
  { id: 5, path: BLOG, label: 'Read Our Blog' },
  { id: 6, path: `${config.FP_APP_URL}legal`, label: 'Legal Mumbo Jumbo' },
  { id: 7, path: CAREERS, label: 'Careers' },
];

export const HELP_MANAGER_DETAILS = {
  phone: {
    hrefNumber: '+19295656850',
    displayNumber: '(929) 565-6850',
  },
  email: 'hi@freshprints.com',
  name: 'Merch Expert',
  title: 'Account Manager',
};

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const ACCOUNT_TYPES = {
  COLLEGIATE: 'collegiate',
  CORPORATE: 'corporate',
  OTHER: 'other',
};

/** Source value passed when navigating from HQ to the main Fresh Prints app. */
export const NAVIGATION_SOURCE_HQ = 'HQ';

/** Full HQ page URL passed on outbound links so destinations can populate Mixpanel referrer. */
export const NAVIGATION_FROM_URL_PARAM = 'fromUrl';

export const USER_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
  DM: 2,
};

export const ACCOUNT_MEMBER_APPROVAL_STATUS = {
  PENDING: 'approval_pending',
  APPROVED: 'approved',
  REJECTED: 'approval_rejected',
  NOT_REQUESTED: 'approval_not_requested',
};
